// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-GlobalNav-GlobalNav-module__localNavContainer__OnBVQ";
var _2 = "assets-js-common-components-MegaNav-MegaNavVariant-components-GlobalNav-GlobalNav-module__localNavLeftSection__X8MzL";
var _3 = "assets-js-common-components-MegaNav-MegaNavVariant-components-GlobalNav-GlobalNav-module__localNavRightSection__a3Irr";
export { _1 as "localNavContainer", _2 as "localNavLeftSection", _3 as "localNavRightSection" }
